import {
  CollectionEntriesQuery,
  CollectionEntryFragment,
  useCollectionEntriesQuery,
  withRequiredVariables,
  withStandardListHook,
} from '@spotify/confidence-graphql';

interface CollectionEntriesVariables {
  parent: string;
}

export const useCollectionEntries = withStandardListHook<
  CollectionEntriesQuery,
  CollectionEntryFragment,
  'collectionEntries',
  CollectionEntriesVariables
>(withRequiredVariables(useCollectionEntriesQuery), 'collectionEntries');
